export default __webpack_public_path__ + "static/media/ic_usdc_24.f07a1d12.svg";